import { motion, AnimatePresence } from 'framer-motion';

export default function BottomSheet({ isOpen, onClose, children, className = '' }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
            onClick={onClose}
          />
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            className={`fixed left-0 right-0 z-50 rounded-t-3xl overflow-hidden ${className}`}
            style={{
              bottom: 'var(--bottom-nav-height)',
              maxHeight: 'calc(90dvh - var(--bottom-nav-height))',
            }}
          >
            <div className="w-12 h-1 bg-fg/30 rounded-full mx-auto mt-3 mb-1" />
            <div className="overflow-y-auto" style={{ maxHeight: 'calc(90dvh - var(--bottom-nav-height) - 24px)' }}>
              {children}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
